import React from 'react';
import styled from 'styled-components/macro';
import { Box, Flex, Button, Text, Image } from '@podiumhq/design-system';
import useMediaQuery from 'hooks/useMediaQuery';
import useTrackAmplitudeEvent from 'hooks/useTrackAmplitudeEvent';
import { useNotificationContext } from 'contexts/NotificationContextProvider';
import accountError from './assets/accountError.png';

const AccountError = ({ handleSubmit }) => {
  const isMobile = useMediaQuery();
  const { errorReason } = useNotificationContext() || {};
  const trackEvent = useTrackAmplitudeEvent(
    'trials.createAccountError.visited'
  );

  const handleTryAgain = async () => {
    await trackEvent('trials.createAccountError.tryAgainClicked');

    handleSubmit();
  };

  const titleText =
    errorReason === 'active_vpn'
      ? 'Please disable your VPN.'
      : errorReason === 'ad_blocker'
      ? 'Please turn off your ad blocker.'
      : 'Something went wrong';
  const bodyText =
    errorReason === 'active_vpn'
      ? 'Your VPN caused an error while we were setting up your Podium account. Please disable it and try again.'
      : errorReason === 'ad_blocker'
      ? 'It looks like you might have an ad blocker turned on. Please turn it off and try again.'
      : 'Hmm, something went wrong while we were setting up your Podium account. Please try again.';

  const renderErrorModal = () =>
    isMobile ? (
      <Wrapper>
        <StyledImage>
          <Image src={accountError} alt="something went wrong" />
        </StyledImage>
        <BoldText>{titleText}</BoldText>
        <StyledText>{bodyText}</StyledText>
        <ButtonWrapper>
          <Button variant="primary" size="lg" onClick={handleTryAgain}>
            Try again
          </Button>
        </ButtonWrapper>
      </Wrapper>
    ) : (
      <Flex justifyContent="center">
        <Box
          position="fixed"
          zIndex="10"
          top="50%"
          margin="18px"
          transform="translate(0, -50%)"
          background="white"
          boxShadow="0px 0px 0px 0.5px rgba(18, 21, 26, 0.08),
0px 8px 16px rgba(18, 21, 26, 0.02),
0px 16px 32px -4px rgba(18, 21, 26, 0.04),
0px 32px 64px -8px rgba(18, 21, 26, 0.04)"
          borderRadius="16px"
          padding="43px"
          width="512px"
          height="325px"
        >
          <Animate>
            <StyledImage>
              <Image src={accountError} alt="something went wrong" />
            </StyledImage>
            <BoldText>{titleText}</BoldText>
            <StyledText>{bodyText}</StyledText>
            <ButtonWrapper>
              <Button variant="primary" size="lg" onClick={handleTryAgain}>
                Try again
              </Button>
            </ButtonWrapper>
          </Animate>
        </Box>
      </Flex>
    );

  return <>{renderErrorModal()}</>;
};

const Animate = styled.div`
  margin-top: -12px;
  animation: wiggleWiggle 0.25s ease-in-out;
  @keyframes wiggleWiggle {
    0% {
      transform: translateX(24px);
      opacity: 0;
    }
    50% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const Wrapper = styled.div`
  padding-top: 28vh;
`;

const StyledText = styled(Text)`
  line-height: 21px;
`;

const StyledImage = styled.div`
  height: 80px;
  width: 80px;
  margin-bottom: 16px;
  margin-left: auto;
  margin-right: auto;
`;

const BoldText = styled.p`
  font-size: 24px;
  font-weight: 600;
  line-height: 150%;
  margin-bottom: 16px;
  text-align: center;
`;

const ButtonWrapper = styled.div`
  margin-top: 24px;
  width: 135px;
  margin-left: auto;
  margin-right: auto;
`;

export default AccountError;
